export default __webpack_public_path__ + "static/media/Banner_image_Delft_small.ea51865f.jpg";